<app-crudbar-nav [title]="title" [visible]="false" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jkcheckboxYN label="星號" #WD027Com id="WD027" [(valueYN)]="item.WD027" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jkdatefield label="工作日期" #WD002Com id="WD002" [(value)]="item.WD002" [readonly]="true">
        </app-jkdatefield>
        <app-jktext label="星期" [value]="item.WD018">
        </app-jktext>
        <app-jktext label="主旨" [value]="item.WD004">
        </app-jktext>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jktextarea height="250px" label="內文" #WD003Com id="WD003" [(value)]="item.WD003" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="RTF內文" #WD026Com id="WD026" [(value)]="item.WD026" [readonly]="true">
        </app-jktextarea>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jkcombobox label="大分類" #WD015Com id="WD015" [(value)]="item.WD015" [items]="srv.mtrWd015List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jkcombobox label="中分類" #WD016Com id="WD016" [(value)]="item.WD016"
          [items]="srv.getMtrwd016List(item.WD015)">
        </app-jkcombobox>
        <app-jkcombobox label="小分類" #WD024Com id="WD024" [(value)]="item.WD024"
          [items]="srv.getMtrwd024List(item.WD015,item.WD016)">
        </app-jkcombobox>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jktext label="工作者" [value]="item.WD014">
        </app-jktext>
        <app-jktext label="客戶代號" [value]="item.WD021">
        </app-jktext>
        <app-jknumberedit label="計費時數" #WD025Com id="WD025" [(value)]="item.WD025" [readonly]="true">
        </app-jknumberedit>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jkcombobox label="狀態" #WD011Com id="WD011" [(value)]="item.WD011" [items]="srv.mtrWd011List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jkcheckboxYN label="結案碼" #WD017Com id="WD017" [(valueYN)]="item.WD017" [readonly]="true">
        </app-jkcheckboxYN>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jktext label="提醒碼" [value]="item.WD010">
        </app-jktext>
        <app-jkdatefield label="提醒日期" #WD005Com id="WD005" [(value)]="item.WD005" [readonly]="true">
        </app-jkdatefield>
        <app-jktext label="提醒時間" [value]="item.WD006">
        </app-jktext>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jktext label="優先順序" [value]="item.WD012">
        </app-jktext>
        <app-jknumberedit label="進度" #WD013Com id="WD013" [(value)]="item.WD013" [readonly]="true">
        </app-jknumberedit>
        <app-jknumberedit label="預估時數" #WD020Com id="WD020" [(value)]="item.WD020" [readonly]="true">
        </app-jknumberedit>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jkcheckboxYN label="私人的" #WD022Com id="WD022" [(valueYN)]="item.WD022" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jkcombobox label="週期" #WD023Com id="WD023" [(value)]="item.WD023" [items]="srv.mtrWd023List"
          [readonly]="true">
        </app-jkcombobox>
        <app-jknumberedit label="金額" #WD019Com id="WD019" [(value)]="item.WD019" [readonly]="true">
        </app-jknumberedit>
      </div>
      <div class="ai-section-header"> <mat-divider></mat-divider> </div>
      <div class="flex">
        <app-jktext label="來源單號" [value]="item.WD028">
        </app-jktext>
        <app-jktext label="建檔時間" [value]="item.WD001">
        </app-jktext>
      </div>
    </div>
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>